module.exports = class IHCityTakatsuki extends IH{
  
  constructor(options) {
    super(options);
    this.options = options;
    
    // マップアプリ標準の設定値
    this.mapOptions.center_cross.display = true;
    this.mapOptions.gmap_options_default.mapTypeControlOptions.position = google.maps.ControlPosition.TOP_RIGHT;
    this.initialSearch = false;
    this.fit_bounds = null;
    this.show_direction_on_marker_click = null; // 道順表示オプション
    this.googleAnalyticsCode = null;
    this.showNumberOfPlaces = false; // 円に関わらず全領域から施設を検索する
    this.isPlaceShowAll = false;
    this.centerChangeRequesting = false;
    this.courseOrder = 'distance';
    
    // 高槻市ハザードマップアプリ固有の設定値
    this.selectRiver = null;
    this.selectedRiver = null;
    this.selectedCourses = [];
    this.layerCache = {};
    this.layerLevel = 0;
    this.layerTimer = null; // Timeout
    this.layerInfo = {};    // Object<InfoWindow>
    this.layerPrefix = 'l/';
    this.layerKeys = [
      'evacuation/area_yodo',
      'evacuation/line',
      'evacuation/area_other',
      'sediment/mudrock_flow_sp',
      'sediment/landslip_sp',
      'sediment/mudrock_flow',
      'sediment/landslip',
      'sediment/landslide',
      'flooded/ai1',
      'flooded/ai2',
      'flooded/ai3',
      'flooded/ai4',
      'flooded/akuta1',
      'flooded/akuta2',
      'flooded/akuta3',
      'flooded/akuta4',
      'flooded/hio1',
      'flooded/hio2',
      'flooded/hio3',
      'flooded/hio4',
      'flooded/minase1',
      'flooded/minase2',
      'flooded/minase3',
      'flooded/minase4',
      'flooded/nyoze1',
      'flooded/nyoze2',
      'flooded/nyoze3',
      'flooded/nyoze4',
      'flooded/yodo1',
      'flooded/yodo2',
      'flooded/yodo3',
      'flooded/yodo4',
      'flooded/yodo5',
      'flooded/pref1',
      'flooded/pref2',
      'flooded/pref3',
      'flooded/pref4',
      'flooded/pref5',
      'flooded/naisui1',
      'flooded/naisui2',
      'flooded/naisui4'
    ];
    this.layerLabels = {
      'landslide': '地すべり警戒区域' +
        '<a href="#" data-legend="sediment" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-landslide"></div>',
      'mudrock_flow': '土石流警戒区域' +
        '<a href="#" data-legend="sediment" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-mudrock-flow"></div>',
      'mudrock_flow_sp': '土石流特別警戒区域' +
        '<a href="#" data-legend="sediment" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-mudrock-flow-sp"></div>',
      'landslip': '急傾斜地警戒区域' +
        '<a href="#" data-legend="sediment" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-landslip"></div>',
      'landslip_sp': '急傾斜地特別警戒区域' +
        '<a href="#" data-legend="sediment" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-landslip-sp"></div>',
      'line': '早期の立退き避難が必要な区域<br />（淀川、ここより南側）' +
      '<a href="#" data-legend="leaving" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
      '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
      '<div class="ct-layer-ex-leaving-yodo"></div>',
      'area_yodo': '早期の立退き避難が必要な区域<br />（淀川）' +
        '<a href="#" data-legend="leaving" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-leaving-yodo"></div>',
      'area_other': '早期の立退き避難が必要な区域' +
        '<a href="#" data-legend="leaving" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
        '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a>' +
        '<div class="ct-layer-ex-leaving-other"></div>',
      'pref': '外水はん濫<br />（はん濫河川: すべて）',
      'akuta': '外水はん濫<br />（はん濫河川: 芥川）',
      'hio': '外水はん濫<br />（はん濫河川: 檜尾川）',
      'minase': '外水はん濫<br />（はん濫河川: 水無瀬川）',
      'nyoze': '外水はん濫<br />（はん濫河川: 女瀬川）',
      'yodo': '外水はん濫<br />（はん濫河川: 淀川）',
      'ai': '外水はん濫<br />（はん濫河川: 安威川）',
      'naisui': '内水はん濫'
    };
    this.riverLevelInfo = {
      1: '<div class="ct-flood-depth-1">浸水深: 0.5m未満' +
          '<a href="#" data-legend="river" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>',
      2: '<div class="ct-flood-depth-2">浸水深: 0.5m～3.0m未満' +
          '<a href="#" data-legend="river" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>',
      3: '<div class="ct-flood-depth-2">浸水深: 0.5m～3.0m未満' +
          '<a href="#" data-legend="river" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>',
      4: '<div class="ct-flood-depth-3">浸水深: 3.0m～5.0m未満' +
          '<a href="#" data-legend="river" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>',
      5: '<div class="ct-flood-depth-4">浸水深: 5.0m以上' +
          '<a href="#" data-legend="river" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>'
    };
    this.inlandLevelInfo = {
      1: '<div class="ct-flood-depth-1">浸水深: 0.5m未満' +
          '<a href="#" data-legend="inland" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>',
      2: '<div class="ct-flood-depth-2">浸水深: 0.5m～1.0m未満' +
          '<a href="#" data-legend="inland" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>',
      4: '<div class="ct-flood-depth-3">浸水深: 1.0m以上' +
          '<a href="#" data-legend="inland" data-role="button" data-icon="arrow-r" data-iconpos="notext" data-theme="c" data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" class="ct-jump-to-legend ui-btn ui-shadow ui-btn-corner-all ui-btn-inline ui-btn-icon-notext ui-btn-up-c">' +
          '<span class="ui-btn-inner"><span class="ui-btn-text"></span><span class="ui-icon ui-icon-arrow-r ui-icon-shadow">&nbsp;</span></span></a></div>'
    };
    this.riverMap = {
      ai: 2,
      akuta: 3,
      hio: 4,
      minase: 5,
      nyoze: 6,
      yodo: 7,
      naisui: 8,
    };
    this.course_selectors = {
      current: '.js-current-course',
      current_holder: '.js-current-course-holder',
      course_list: '.iw-courses',
      course_list_header: '.iw-courses-heading',
      course_open: '.js-course-open'
    };
    /**
     * courses = [
     *  {
     *    id:     Number,
     *    name:   String,
     *    places: [Number],
     *    course_places: [Number]
     *    type:   String,
     *    draw_from: String (places or points or places)
     *    draw_from_points_by: [[Number, Number]]
     *    draw_from_places_by: String (road, straight)
     *    draw_from_places_travel_mode: String (WALKING | DRIVING)
     *    help:   String
     *  }
     * ]
     */
    this.courses = [];
    this.course_data = null;                                    // キャッシュ
    this.courses_keep_to_show_direction_on_marker_click = null; // 道順表示オプションを退避する
    this.courseRenderers = [];
    this.courseOrder = 'seq';                                   // seq or distance
  
    // レイヤ表示欄の要素(jQuery Element)
    this.layerIndicator = null;
    this.riverIndicator = null;
    this.riverNameIndicator = null;
    this.inlandIndicator = null;
    this.floodSedimentIndicator = null;
    this.sedimentIndicator = null;
    
    // 河川リスト選択値と河川名の対応
    this.riverName = {
      ai: '安威川',
      akuta: '芥川',
      hio: '檜尾川',
      minase: '水無瀬川',
      nyoze: '女瀬川'
    };
  
    this.apiBaseURL = 'https://www.hz-kutc.net/city.takatsuki/hazard/';
    this.kmzAPI = this.apiBaseURL + 'map/polygon/';
    this.layerInfoAPI =  this.apiBaseURL + 'map/search?';
    this.townKMLPath = this.apiBaseURL + 'sites/city.takatsuki/polygon_data/area/';

    // POI（GoogleMapデフォルトの情報ウィンドウ）
    this.poi = null;
    
    this.renderSearchMenu = false;
  
    this.townLayer = [];
  
    // 現在地がビューポート外の時、地図中心を現在地に合わせるかどうか
    this.fitToLocationMarker = true;
    
    // 管理画面等でのオプション設定値を上書き
    this.setOptions(this.options);
    
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init(){
  
    let that = this;
  
    // コース表示は距離順にする
    that.courseOrder = 'distance';
    
    $(that).on('ready', function(){
  
      let flood = true;
      let river = true;
      let dosha = true;
      
      let qs = that.getQueryString();
      
      // URLパラメタで災害を表示する時は、サイドパネルの災害選択の初期化をオフにする
      flood = !('hanran' in qs);
      river = ( flood || (qs.hanran === 'naisui') );
      dosha = !('dosha' in qs);
  
      // URLパラメタで避難所を表示する時は、地図中心を現在地に合わせる動作をオフにする
      // 　・指定した避難所に地図中心を合わせるため
      // 　・災害表示パラメタとの組み合わせる時に、地図中心を現在地に合わせる動作が働き
      // 　　地図中心位置がおかしくなる
      this.fitToLocationMarker = !('show_place' in qs);
      
      // レイヤ種表示欄を生成・表示する
      that.createLayerIndicator();
      // リストやラジオボタンの選択を初期化する
      that.initSelectors(flood, river, dosha);
      // レイヤを初期化する
      that.initLayers();
      // おすすめコースを初期化する
      that.initCourse();
      // パネルコンテンツの高さを調整する
      that.readyForPagesAndPanels();
      // 一部のコンテンツを削除する(標高、おすすめコース)
      that.removeContents();
      // POIをオーバライドして、外部からメソッドで開閉可能できるようカスタマイズする
      that.setClosablePOI();
      // 町名指定パネルの挙動を調整する
      that.controlTownIndex();
  
      // URLパラメタによる処理
      // 　・町ID指定による基準位置変更
      // 　・特定の災害の表示
      setTimeout(function(){
        
        that.changeCenterByTownID();
        that.changeCenterByMultiTownID();
  
        let riverSelector = $('.js-river-select');
        let floodSelector = $(".kiken-shinsui");
        let sedimentSelector = $('.js-saigai-select');
  
        if (qs.dosha) {
          sedimentSelector.prop('checked', true).checkboxradio('refresh');
          sedimentSelector.trigger('change');
        }
        
        if (qs.hanran === 'naisui') {
  
          floodSelector.find('input').each(function () {
    
            if ($(this).val() == '2') {
              $(this).prop('checked', true);
            } else {
              $(this).prop('checked', false);
            }
    
            $(this).checkboxradio('refresh');
    
          });
  
          floodSelector.trigger('change');
          
        } else if ('hanran' in qs) {
  
          floodSelector.find('input').each(function () {
    
            if ($(this).val() == '1') {
              $(this).prop('checked', true);
            } else {
              $(this).prop('checked', false);
            }
    
            $(this).checkboxradio('refresh');
    
          });
          
          let riverName;
          if (qs.hanran === 'all') {
            riverName = 'pref';
          } else {
            riverName = qs.hanran;
          }
          
          riverSelector.val(riverName);
          riverSelector.trigger('change');
  
          floodSelector.trigger('change');
          riverSelector.selectmenu().selectmenu('refresh', true);
          
        }
        
      }, 1000);
  
      // URLパラメタによる避難所表示と災害表示が終われば、地図中心を現在地に合わせる動作を有効にする
      if (!that.fitToLocationMarker) {
  
        $(that.map).on('ihDisplayedAllMarkers', function (event, places, marker, popup) {
  
          let ids = qs.show_place.split(',');
          let id = parseInt(ids[0], 10);
          
          if ( id !== places[0].id ) {
            that.fitToLocationMarker = true;
          }
          
        });
        
      }
      
      // ====================== マップアプリ間で汎用性のある処理 ======================
  
      // Google Analytics Tracking
      if (ga){
    
        // 現在地移動ボタンのクリック
        $('.js-user-location').on('click', function(){
          ga('send', 'event', 'button', 'click', $(this).text().trim());
        });
    
        // 検索を実行
        $(that).on('ihBeforeSearch', function(event, request){
      
          if (request.isOrigined('user')) {
            ga('send', 'event', 'system', 'search', request.search_url);
          }
      
        });
    
        // 施設詳細を開いた時
        $( "#page-place" ).on( "panelopen", function( event, ui ) {
      
          let label = [
            $(this).find('.iw-type').text(),
            $(this).find('.iw-name').text(),
            $(this).data('place-id')
          ].join(':');
      
          ga('send', 'event', 'place', 'show', label);
      
        });
  
        // GoogleMapsの表示言語切替え
        $('.js-locale').on('change', function() {
          window.location.href = window.location.pathname + '?locale=' + $(this).val();
        });
    
        // パネルを開いた時（施設詳細を開いた時以外）
        $( ".ui-panel" ).on( "panelopen", function( event, ui ) {
      
          if ($(this).is($('#page-place'))) {
            return;
          }
      
          ga('send', 'event', 'panel', 'show', $(this).find('.ui-header h1').text());
      
        });
    
        $( ".js-move-list" ).on( "click", 'a', function() {
          // data属性付けるの難しそう（jqmが書き換えてる？）
          // console.log($(this));
          // ga('send', 'event', 'place', 'show', $(this).data('place-id'));
        });
    
      }
  
      //「現在地」「情報」メニュー
      let popupLocation = $('#page-location');
      let popupInfo = $('#popup-info');
  
      // 「現在地」「情報」メニューを開くと、モダール背景に色を着ける
      popupLocation.popup({
        overlayTheme: "a"
      });
      popupInfo.popup({
        overlayTheme: "a"
      });
  
      //「現在地」「情報」メニューを開いている時、ウィンドウサイズが変ると、メニューを閉じる
      popupLocation.on('popupbeforeposition', function(event, ui) {
        
        $(window).resize(function() {
          popupLocation.popup('close');
        });
        
      });
      popupInfo.on('popupbeforeposition', function(event, ui) {
  
        $(window).resize(function() {
          popupInfo.popup('close');
        });
  
      });
  
      // 幅狭い場合、一覧クリック時にパネルを閉じる（検索結果、おすすめコース、名前で検索）
      // sakaimap版では、クリックイベントが拾えなかったので、document全体で拾う
      $(document).on('click', '.sr-link,.js-course-point,.js-move-link', function(){
        if (that.isMobileSize()){
          $(this).closest('.ui-panel').panel("close");
        }
      });
  
      // 展開・格納が可能なメニューにアニメーションをつける
      let panelContent = $('.panel-content');
      panelContent.on('expand', '.ui-collapsible', function() {
        $(this).children().next().hide();
        $(this).children().next().slideDown(200);
      });
      panelContent.on('collapse', '.ui-collapsible', function() {
        $(this).children().next().slideUp(200);
      });
  
      // パネルを開く時はストリートビューを閉じる
      $( ".ui-panel" ).on( "panelbeforeopen", ( event, ui ) => {
        let panorama = that.map.getMap().getStreetView();
        panorama.setVisible(false);
      });
  
      // おすすめパネル開いた時
      // $( "#page-recommend" ).on( "panelopen", function( event, ui ) {
      //   console.log('panelopen');
      // });
      // $(that).on('ihBeforeDisplayCourse', function(route, course){
      //   // 一時的に、マーカークリック時の道順表示を無効にする
      //   that.show_direction_on_marker_click = false;
      // });
      
      // GPS現在地連動モードに移行
      $('.js-user-location').on('click', function(){
    
        let elm = $(this);
    
        that.shiftToLocationMode().then(function(){
          elm.closest('.ui-popup').popup('close');
        });
    
        return false;
    
      });
  
      // 地図中心を現在地にする
      // TODO: Controller.jsにも処理が割当てられているので、Controller.jsと調整する
      $('.js-move-map-center').on('click', function(){
    
        let latlng = that.map.getCenter();
    
        that.map.updateCurrentLocation(latlng);
    
        that.reSearch({lat: latlng.lat(), lng: latlng.lng()}).then(function(res){
          $(that).trigger('ihUpdateCenterMarker', res);
        });
    
        $(this).closest('.ui-popup').popup('close');
    
      });
  
      // 現在地マーカの位置に移動
      // TODO: Controller.jsにも処理が割当てられているので、Controller.jsと調整する
      $('.js-move-center').on('click', function(){
    
        let loc = that.map.getCurrentSearchLocation();
    
        that.map.moveMap(loc.lat(), loc.lng());
    
        $(this).closest('.ui-popup').popup('close');
    
      });
      
      // 現在地・情報ポップアップメニューから項目を選んだ時に、ポップアップを閉じる
      $('.js-close-popup').on('click', function(){
        $(this).closest('.ui-popup').popup('close');
      });
  
      // ヘッダに住所を表示する（表示タイミング: 読み込み時、中心位置変更時）
      that.displayLocationBar();
      google.maps.event.addListener(that.map.getMap(), 'idle', function () {
        that.displayLocationBar();
      });
  
      // ストリートビューを開いた時は住所表示をオフにする
      let streetView = that.map.getMap().getStreetView();
      let locationBar = $('.location-bar');
      streetView.addListener("visible_changed", function(){
    
        let svVisible = streetView.getVisible();
  
        if (svVisible) {
          locationBar.hide();
        } else {
          locationBar.show();
        }
        
      });
      
      $('#page-procedure').panel('open');
      
      // 防災アプリのリンクを追加（直接リンクを設置すると、相対パス化される）
      $('#ct_booklet_link1').attr('href', 'http://www.hz.kutc.kansai-u.ac.jp/city.takatsuki/bousai/booklet/2_suigai/2_1.html');
      $('#ct_booklet_link2').attr('href', 'http://www.hz.kutc.kansai-u.ac.jp/city.takatsuki/bousai/booklet/3_dosha/3_1.html');
      $('#ct_booklet_link3').attr('href', 'http://www.hz.kutc.kansai-u.ac.jp/city.takatsuki/bousai/booklet/4_koudou/4_1.html');
      $('#ct_booklet_link4').attr('href', 'http://www.hz.kutc.kansai-u.ac.jp/city.takatsuki/bousai/booklet/3_dosha/3_2.html');
  
      // ====================== レイヤ関連の処理 ======================
      
      $('.js-layer-input').on('change', function(){
        
        let id = $(this).data('id');
        id = that.layerPrefix + id;
        let checked = $(this).get(0).checked;
        
        if (checked) {
          that.showLayer(id);
        } else {
          that.hideLayer(id);
        }
    
      });
  
      // ====================== おすすめコース関連の処理 ======================
  
      let holder = $(that.course_selectors.current_holder);
      holder.hide();
  
      // コース一覧のハンドラ設定
      $(that.course_selectors.course_open).each(function(){
        
        let c = $(this);
        let id = c.data('id');
        
        c.on('click', () => {
          that.openCourse(id).then(() => {
            $('#page-list').panel('open');
          });
        });
        
      });
  
      // 結果リストのハンドラ設定
      $(that.course_selectors.current).on('click', function(){
        
        let data = that.getCourseDataById($(this).data('id'));
        
        if (data.visible) {
          $('#page-recommend').panel('open');
        }
        
      });
  
      // ====================== ハザードマップ固有性の高い処理 ======================
    
      // ポリゴン検索試作
      // 道順内に川があるかどうか試作
      /*
       $(that).on('ihAfterDirection', function(event, res){
       var paths = res.routes[0].overview_path;
       paths = paths.map(function(path){
       return path.lat() + ':' + path.lng();
       }).join(',');
     
       var dfds = [];
       dfds.push(that.polygonWithin({scopes: 'river'}, {polygons: paths}));
     
       $.when.apply($, dfds).then(function(){
       console.log('Directions', arguments);
       })
       })
       */
      
      
      let t = $('<div class="ct-layer-indicator"></div>');
      t.appendTo($('#gmap'));
    
      /**
       * ----------------------------------------
       * 浸水深、危険箇所
       * ----------------------------------------
       */
      // 浸水深
      $('.js-level-input').on('change', function(){
        that.layerLevel = $(this).val();
        that.refreshRiver($('.js-river-input').val(), that.layerLevel);
      });
    
      // 河川
      $('.js-river-input').on('change', function(){
        that.layerLevel = $('.js-level-input').val();
        that.refreshRiver($(this).val(), that.layerLevel);
      });
      $('.js-river-select').on('change', function() {
        
        that.layerLevel = 5;
        that.selectRiver = $(this).val();
        
        // 外水はん濫レイヤ表示処理が重複しているため、コメントアウト [2017.8.10]
        //that.refreshRiver($(this).val(), that.layerLevel);
        
      });
  
      let legendSediment = $('.ct-sediment');
      
      // 土砂災害フリップ
      $('.js-saigai-select').on('change', function(){
  
        that.closeLayerInfo();
        
        if (that.poi) {
          that.poi.close();
        }
        
        let checked;
        
        if ($(this).is(':checkbox')) {
          checked = $(this).prop('checked');
        } else {
          checked = $(this).val() === 'on';
        }
        
        if (checked){
          
          // 土砂災害の凡例を表示
          legendSediment.show();
          
          // レイヤ種表示欄を表示
          that.layerIndicator.show();
          
          // レイヤ種表示欄に土砂災害を表示
          that.sedimentIndicator.show();
  
          // レイヤ種表示欄に水害が表示されている場合、区切り(/)を表示
          if ( that.riverIndicator.is(':visible') || that.inlandIndicator.is(':visible') ) {
            that.floodSedimentIndicator.show();
          }
          
          that.showLayer('sediment/landslide');
          that.showLayer('sediment/mudrock_flow');
          that.showLayer('sediment/mudrock_flow_sp');
          that.showLayer('sediment/landslip');
          that.showLayer('sediment/landslip_sp');
          that.showLandSlideCourse();
          
        } else {
          
          // 土砂災害の凡例を非表示
          legendSediment.hide();
  
          // レイヤ種表示欄の土砂災害を非表示
          that.sedimentIndicator.hide();
  
          // レイヤ種表示欄の区切り(/)を非表示
          that.floodSedimentIndicator.hide();
  
          // レイヤ種表示欄に水害が表示されていない場合、レイヤ種表示欄を非表示
          if ( that.riverIndicator.is(':hidden') && that.inlandIndicator.is(':hidden') ) {
            that.layerIndicator.hide();
          }
          
          that.hideLayer('sediment/landslide');
          that.hideLayer('sediment/mudrock_flow');
          that.hideLayer('sediment/mudrock_flow_sp');
          that.hideLayer('sediment/landslip');
          that.hideLayer('sediment/landslip_sp');
          that.hideLandSlideCourse();
          
        }
      });
      
      let riverSelector = $('.kasen-sinsui');
      let legendRiverFlood = $('.ct-river-flood');
      let legendInlandFlood = $('.ct-inland-flood');
      let legendLeavingYodo = $('.ct-early-leaving-yodo');
      let legendLeavingOther = $('.ct-early-leaving-other');
      let legendLeavingAll = $('.ct-early-leaving-all');
      
      riverSelector.addClass('ui-disabled');
      
      //外水と内水を切り替えるチェックボックスの処理
      $(".kiken-shinsui").on('change', function(){
  
        that.closeLayerInfo();
        
        if (that.poi) {
          that.poi.close();
        }
  
        // レイヤ種表示欄の水害を非表示
        that.riverIndicator.hide();
        that.inlandIndicator.hide();
  
        // レイヤ種表示欄の河川名を非表示
        that.riverNameIndicator.hide();
        
        // レイヤ種表示欄の区切り(/)を非表示
        that.floodSedimentIndicator.hide();
  
        // レイヤ種表示欄に土砂災害が表示されていない場合、レイヤ種表示欄を非表示
        if ( that.sedimentIndicator.is(':hidden') ) {
          that.layerIndicator.hide();
        }
        
        riverSelector.addClass('ui-disabled');
        legendRiverFlood.addClass('ct-display-none');
        legendInlandFlood.addClass('ct-display-none');
        legendLeavingYodo.addClass('ct-display-none');
        legendLeavingOther.addClass('ct-display-none');
        legendLeavingAll.addClass('ct-display-none');
        
        that.hideLayers(/^flooded\//);
        that.hideAllRiverCourse();
        that.hidenaisuiCourse();
        that.hideLayers('evacuation/area_other');
        that.hideLayers('evacuation/area_yodo');
        that.hideLayers('evacuation/line');
        
        let suigai = $("input[name='suigai_set']:checked").val();
        
        if (suigai == 2) {
  
          // レイヤ選択の連打防止のため、一旦無効化する
          // 施設オブジェクトリクエスト後に有効化
          $(this).addClass('ui-disabled');
          
          // レイヤ種表示欄を表示
          that.layerIndicator.show();
          
          // レイヤ種表示欄に内水はん濫を表示
          that.inlandIndicator.show();
  
          // レイヤ種表示欄に土砂災害が表示されている場合、区切り(/)を表示
          if ( that.sedimentIndicator.is(':visible') ) {
            that.floodSedimentIndicator.show();
          }
          
          legendInlandFlood.removeClass('ct-display-none');
  
          that.shownaisuiCourse();
          that.showLayer('flooded/naisui');
          
        } else if (suigai == 1) {
  
          riverSelector.removeClass('ui-disabled');
          legendRiverFlood.removeClass('ct-display-none');
  
          that.showRiverCourse(that.selectRiver);
          that.showLayer('flooded/' + that.selectRiver);
        
          //早期立ち退き避難が必要な区域の切り替え
          if (that.selectRiver === 'yodo') {
  
            // レイヤ選択の連打防止のため、一旦無効化する
            // 施設オブジェクトリクエスト後に有効化
            $(this).addClass('ui-disabled');
            
            // レイヤ種表示欄を表示
            that.layerIndicator.show();
  
            // レイヤ種表示欄に外水はん濫を表示
            that.riverIndicator.show();
            
            // レイヤ種表示欄に河川名を表示
            that.riverNameIndicator.text('（淀川）' );
            that.riverNameIndicator.show();
  
            // レイヤ種表示欄に土砂災害が表示されている場合、区切り(/)を表示
            if ( that.sedimentIndicator.is(':visible') ) {
              that.floodSedimentIndicator.show();
            }
            
            legendLeavingYodo.removeClass('ct-display-none');
            
            that.showLayer('evacuation/area_yodo');
            that.showLayer('evacuation/line');
            
          }
          else if (that.selectRiver === 'pref') {
  
            // レイヤ選択の連打防止のため、一旦無効化する
            // 施設オブジェクトリクエスト後に有効化
            $(this).addClass('ui-disabled');
            
            // レイヤ種表示欄を表示
            that.layerIndicator.show();
  
            // レイヤ種表示欄に外水はん濫を表示
            that.riverIndicator.show();
  
            // レイヤ種表示欄に河川名を表示
            that.riverNameIndicator.text('（すべての河川）' );
            that.riverNameIndicator.show();
  
            // レイヤ種表示欄に土砂災害が表示されている場合、区切り(/)を表示
            if ( that.sedimentIndicator.is(':visible') ) {
              that.floodSedimentIndicator.show();
            }
            
            legendLeavingAll.removeClass('ct-display-none');
            
            that.showLayer('evacuation/area_other');
            that.showLayer('evacuation/area_yodo');
            that.showLayer('evacuation/line');
            
          }
          else if (that.selectRiver === 'ai' || that.selectRiver === 'akuta' || that.selectRiver === 'hio' || that.selectRiver === 'minase' || that.selectRiver === 'nyoze') {
  
            // レイヤ選択の連打防止のため、一旦無効化する
            // 施設オブジェクトリクエスト後に有効化
            $(this).addClass('ui-disabled');
            
            // リスト選択値から河川名を取得
            let riverName = that.getRiverName(that.selectRiver);
            
            // レイヤ種表示欄を表示
            that.layerIndicator.show();
  
            // レイヤ種表示欄に外水はん濫を表示
            that.riverIndicator.show();
  
            // レイヤ種表示欄に河川名を表示
            that.riverNameIndicator.text('（' + riverName + '）' );
            that.riverNameIndicator.show();
  
            // レイヤ種表示欄に土砂災害が表示されている場合、区切り(/)を表示
            if ( that.sedimentIndicator.is(':visible') ) {
              that.floodSedimentIndicator.show();
            }
            
            legendLeavingOther.removeClass('ct-display-none');
            
            that.showLayer('evacuation/area_other');
            
          }
        
        }
        
      });
    
      /**
       * 選択中の河川がわかるようにする。上手くいかない。
       */
      //$('.js-river-select').each(function() {
      //  var select = $(this);
      //  select.find('option').each(function(){
      //    $(this).data('label', $(this).text);
      //  });
      //  select.on('change', function(){
      //    select.find('option').each(function(){
      //      if ($(this).is(':selected')){
      //        $(this).text($(this).data('label') + ' 【選択中】');
      //      }else{
      //        $(this).text($(this).data('label'));
      //      }
      //    });
      //  });
      //});
      
      // 利用手順ボタン
      let homeControlDiv = document.createElement('div');
      that.homeControl(homeControlDiv);
      //let homeControl = new HomeControl(homeControlDiv, that.map);
    
      homeControlDiv.index = 1;
      that.map.getMap().controls[google.maps.ControlPosition.TOP_LEFT].push(homeControlDiv);
  
      // let procedure = $('#page-procedure');
      
      // // 利用手順ポップアップの高さ調整
      // procedure.on({
      //
      //   // パネル内リンク(ジャンプ)
      //   panelopen: function(){
      //
      //     let content = procedure.find(".ui-content");
      //
      //     content.find('a[href^=#]').each(function(){
      //
      //       let target = $(this).attr('href');
      //       let targetElem = $(target);
      //
      //       $(this).on('click', function(){
      //         let pos = targetElem.offset().top - targetElem.outerHeight(true) + content.scrollTop() - 20;
      //         //content.scrollTop(pos);
      //         content.animate({scrollTop:pos}, 200, 'swing');
      //         return false;
      //       });
      //
      //     });
      //
      //   }
      //
      // });
      
    });
  
    /*　応急処置
     ・result.floodedの値がおかしいので、getLayerInfoで作成したラベルをそのまま使用
     */
    $(that).on('ihLayerOpenInfoWindow', (event, iw, name, latlng) => {
    
      if (name.match(/flooded/)) {
      
        let c = iw.getContent();
        let params = {lat: latlng.lat(), lng: latlng.lng(), scopes: 'flooded'};
      
        iw.setContent("");
        iw.setContent(c);
      
        that.getPolygonWithin(params).then((result) => {
        
          if (result.flooded) {
          
            let str = "";
          
            for (let i in result.flooded) {
            
              if (name.indexOf(i) !== -1) {
                let level = result.flooded[i];
                str += that.layerLabels[i] + '';
              }
            
            }
            //iw.setContent(str);
          }
        });
      }
    });
    
    $(that).on('ihAfterRequestPlaces', (event, request, places) => {
      
      // 浸水レイヤ表示ボタンを有効化する（連打防止）
      $('.kiken-shinsui').removeClass('ui-disabled');
      
      // ビューポート座標が確定している場合のみ
      if (that.map.getBounds() && that.fitToLocationMarker) {
  
        // 現在地マーカの座標を取得
        let currentLocation = that.map.getCurrentSearchLocation();
  
        // 現在地マーカがマップビューポートに収まっていなければ、
        if ( currentLocation.lat() > that.map.getNorthEnd() ||
             currentLocation.lng() > that.map.getEastEnd()  ||
             currentLocation.lat() < that.map.getSouthEnd() ||
             currentLocation.lng() < that.map.getWestEnd()
        ) {
    
          // 現在地マーカの位置にマップ中心を合わせる
          that.map.setCenter(currentLocation);
    
        }
        
      }
      
      let $holder = $(that.course_selectors.current_holder);
      let $course = $(that.course_selectors.current);
      let data = request.get('course_data');
    
      if (data) {
      
        $course.data('id', data.id);
        $course.text(data.name);
        $holder.show();
      
        let row = $('.js-course-open[data-id=' + data.id + ']');
        let col = row.closest('.ui-collapsible');
      
        col.find('h3.ui-collapsible-heading-collapsed').trigger('click');
        col.find('.js-selected').removeClass('js-selected');
        row.addClass('js-selected');
      
        let descriptionHtml = data.description;
        let description = $holder.find('.js-current-course-description');
      
        if (descriptionHtml) {
          description.html(descriptionHtml);
          description.show();
        } else {
          description.hide();
        }
  
        // コース描画
        that.displayCourseRoute(places, request.get('course_data'));
        
      } else {
        $('.js-current-course').text('');
        $holder.hide();
      }
      
    });
  
    // マーカーポップアップ・詳細パネルの内容の書き換え
    $(that).on('ihFillMarkerPopup', function(event, place, popup){
    
      that.createCarousel(place, popup);
      
      let $p = $(popup);
    
      // ストリートビューのサムネイル・リンク描画（ポップアップ）
      if (place.sv_heading && typeof place.sv_heading !== 'undefined') {
      
        let lat = place.sv_lat || place.lat;
        let lng = place.sv_lng || place.lng;
      
        if (lat && lng) {
        
          let param = {
            size: '180x80',
            sensor: false
          };
          param.heading = place.sv_heading;
          param.fov = place.sv_fov;
          param.pitch = place.sv_pitch;
          param.location = lat + ',' + lng;
          param.key = that.options.googleMapsAPIKey;
        
          let url = 'https://maps.googleapis.com/maps/api/streetview?' + jQuery.param(param);
        
          $p.find('.iw-sv').show();
          $p.find('.iw-sv').on('click', function(event){
          
            // ストリートビューに切り替え
            let panorama = that.map.getMap().getStreetView();
            panorama.setVisible(true);
            panorama.setPosition(new google.maps.LatLng(lat, lng));
            panorama.setPov({
              heading: parseInt(param.heading),
              pitch: parseInt(param.pitch)
            });
          
            event.stopPropagation();
          
            return false;
          
          });
        
          $p.find('.iw-sv img').attr('src', url);
        
        }　else　{
          $p.find('.iw-sv').hide();
        }
      }　else　{
        $p.find('.iw-sv').hide();
      }
    
      // 空白の項目を非表示（詳細パネル）
      $p.find('.iw-item').each(function(){
      
        let td = $(this).find('td'); // TODO
      
        if (td.length > 0 && td.text() === '')　{
          $(this).hide();
        }
      
      });
    
      // 施設詳細画面に、おすすめコースへのリンクを追加する
      let $c = $p.find(that.course_selectors.course_list);
      let $tpl = $c.find('.js-template').hide();
    
      if ($c.length) {
      
        $c.empty();
      
        $p.find(that.course_selectors.course_list_header).hide();
      
        $.each(that.courses, function(i){
        
          let courseObj = this;
        
          if ($.inArray(place.id, courseObj.places) >= 0) {
          
            // コースがあれば表示する
            $p.find(that.course_selectors.course_list_header).show();
            let link = $tpl.clone().removeClass('js-template').show();
            $c.append(that.fillCourseListItem(link, courseObj));
          
          }
        
        });
      
        $c.append($tpl);
      
      }
    
    });
  
    $(that).on('ihClickMarker', () => {
      that.closeLayerInfo();
    });
    
    $(that).on('ihClear', () => {
      that.clearCourseRoutes();
      that.courseSelected = [];
      // 一時的に無効化したマーカークリック時の道順表示を再有効化する
      // that.show_direction_on_marker_click = that.courses_keep_to_show_direction_on_marker_click;
    });
  
    $(that).on('ihBeforeDisplayCourse', (event, address) => {
      // that.clearFacilitySelector();
      that.controller.clearAllSelector();
    });
    
    // 現在地を取得すると、その位置までマップ中心を移動
    // $(that).on('ihStartWatchingPosition', (event, position) => {
    //   let lat = position.coords.latitude, lng = position.coords.longitude;
    //
    //   // ih.geolocation でも地図を移動させている
    //   // that.map.moveMap(lat, lng);
    //
    //   // 現在地変更（マーカ表示）
    //   that.map.updateCurrentLocation(new google.maps.LatLng(lat, lng));
    //
    //   // 現在地から検索？
    //   that.reSearch({lat: lat, lng: lng}).then(function(res){
    //     $(that.map).trigger('ihUpdateCenterMarker', res);
    //   });
    //
    // });
    
  }
  
  // ====================== ハザードマップ固有性の高いメソッド ======================
  
  // ローカルでは無理
  kmzPath(name){
    return this.kmzAPI + name + '?format=kmz';
  }
  
  refreshRiver(river, level){
    
    // TODO 表示完了した後に消したほうが綺麗かも
    this.hideLayers(/^flooded\//);
    this.showRiver(river);
    
    this.hideAllRiverCourse();
    this.showRiverCourse(river);
    
    // Todo 存在しないメソッド [2017.7.28]
    // if (river === 'pref') {
    //   this.showALLRiverCourse();
    // }
    
  }
  
  showRiver(river){
  
    //内水から外水に切り替えた際にもともと設定していた河川の浸水深を表示できるようにグローバル変数（selectRiver）にデータを格納
    this.selectRiver = river;
    
    this.showLayer('flooded/' + river);
    
    //早期立ち退き避難が必要な区域の切り替え
    if (river === 'yodo') {
      this.hideLayers('evacuation/area_other');
      this.showLayer('evacuation/area_yodo');
    }
    else if (river === 'pref') {
      this.showLayer('evacuation/area_other');
      this.showLayer('evacuation/area_yodo');
    }
    else if (river === 'ai' || river === 'akuta' || river === 'hio' || river === 'minase' || river === 'nyoze') {
      this.showLayer('evacuation/area_other');
      this.hideLayers('evacuation/area_yodo');
    }
    else {
      this.hideLayers('evacuation/area_other');
      this.hideLayers('evacuation/area_yodo');
    }
    
  }
  
  /**
   * ----------------------------------------
   * 危険箇所の避難場所をおすすめコースとして描画。複数コース同時にできるように
   * ----------------------------------------
   */
  showLandSlideCourse(){
    this.selectedCourses.push(1);
    this.openCourseMulti(this.selectedCourses);
  }
  hideLandSlideCourse(){
    this.selectedCourses = _.without(this.selectedCourses, 1);
    this.openCourseMulti(this.selectedCourses);
  }
  showRiverCourse(river){
    
    this.selectedRiver = river;
    
    // 河川IDとコースIDが一致するコースのみ表示（おすすめコースデータに登録されている）
    if (river === 'pref') {
  
      _.forEach(this.courses, (c) => {
        _.forEach(this.riverMap, (r) => {
          
          if (c.id === r){
            this.selectedCourses.push(c.id);
          }
          
        });
      });
      
      // コースが登録されていない河川も対象となってしまうためコメントアウト
      //this.selectedCourses = _.union(this.selectedCourses, _.values(this.riverMap));
      
    } else if (this.riverMap[river]) {
      this.selectedCourses.push(this.riverMap[river]);
    }
    this.openCourseMulti(this.selectedCourses);
  }
  hideAllRiverCourse(){
    _.each(_.values(this.riverMap), (v) => {
      this.selectedCourses = _.without(this.selectedCourses, v);
    });
    this.openCourseMulti(this.selectedCourses);
  }
  shownaisuiCourse(){
    
    // 指定したIDの施設コース(セット)が設定されているか
    let course = _.find(this.courses, (c) => {
      return c.id === 8;
    });
  
    // 施設コースが設定されている場合のみ、コースIDを登録し、描画する
    if (course) {
      this.selectedCourses.push(8);
    }
    
    this.openCourseMulti(this.selectedCourses);
    
  }
  hidenaisuiCourse(){
    this.selectedCourses = _.without(this.selectedCourses, 8);
    this.openCourseMulti(this.selectedCourses);
  }
  
  /**
   * レイヤ種表示欄を生成・表示する
   */
  createLayerIndicator(){
    
    this.layerIndicator = $('<div class="ct-layer-indicator"></div>');
    this.riverIndicator = $('<span class="ct-river-flood-indicator">外水はん濫</span>');
    this.riverNameIndicator = $('<span class="ct-river-name-indicator"></span>');
    this.inlandIndicator = $('<span class="ct-inland-flood-indicator">内水はん濫</span>');
    this.floodSedimentIndicator = $('<span class="ct-flood-and-sediment-indicator"> / </span>');
    this.sedimentIndicator = $('<span class="ct-sediment-indicator">土砂災害</span>');
  
    this.layerIndicator.appendTo($('#gmap'));
    this.riverIndicator.appendTo(this.layerIndicator);
    this.riverNameIndicator.appendTo(this.layerIndicator);
    this.inlandIndicator.appendTo(this.layerIndicator);
    this.floodSedimentIndicator.appendTo(this.layerIndicator);
    this.sedimentIndicator.appendTo(this.layerIndicator);
    
  }
  
  /**
   * 河川名を取得する
   * @param key
   * @returns {*}
   */
  getRiverName(key){
    return this.riverName[key];
  }
  
  /**
   * ----------------------------------------
   * 利用手順
   * ----------------------------------------
   */
  homeControl(controlDiv) {
    
    // Set CSS styles for the DIV containing the control
    // Setting padding to 5 px will offset the control
    // from the edge of the map.
    controlDiv.style.padding = '5px';
    
    // Set CSS for the control border.
    let controlUI = document.createElement('div');
    controlUI.classList.add('ct-procedure-button');
    controlUI.innerHTML = '操作手順';
    controlUI.style.cursor = 'pointer';
    controlDiv.appendChild(controlUI);
    
    // Setup the click event listeners: simply set the map to Chicago.
    google.maps.event.addDomListener(controlUI, 'click', () => {
      $('#page-procedure').panel('open');
    });
    
  }
  
  /**
   * Override
   */
  /*  応急処置
      ・ラベル検索が部分一致になっているため、検索ミスが発生する問題の修正 (e.g. 'ai' -> 'naisui')
      ・ゼミサーバ版最新に合わせて、ラベルはdivで囲わずにreturn
   */
  getLayerInfo(key){
    let that = this;
  
    let level = key.match(/\d/);
    let levelInfo = null;
    
    for (let val in that.layerLabels){
      
      if (key.indexOf('/' + val) >= 0) {
  
        if (val === 'naisui') {
          levelInfo = that.inlandLevelInfo;
        } else {
          levelInfo = that.riverLevelInfo;
        }
        
        if (level) {
          level = level[0];
          return '<div class="ct-layer-info">' + that.layerLabels[val] +
                 '<br />' + levelInfo[level] +
                 '</div>';
        } else if (key.split('/')[1] === val) {
          return '<div class="ct-layer-info">' + that.layerLabels[val] + '</div>';
        }
        
      }
      
      //if (key.indexOf(val) >= 0){
      
        // var level = key.match(/\d/);
        // if (level){
        //   level = level[0];
        //   return that.layerLabels[val];
        //   return '<div class="ih-layer-info"><p>' + that.layerLabels[val] + '</p>' +
        //     // '<p class="river_info">' + that.riverLevelInfo[level] + '</p>' +
        //     '</div>';
        // }else{
        //   return '<div class="ih-layer-info"><p>'+that.layerLabels[val] + '</p></div>';
        // }
    
    }
  
  }
  /**
   * Origin (旧・getLayerInfo())
   */
  _getLayerInfo(key){
    return '<p>'+key+'</p>';
  }
  
  openCourseMulti(ids){
    
    let that = this;
    
    if (ids.length === 0) {
      that.clear();
      return;
    }
  
    let cd = _.reduce(ids, (obj, id) => {
      
      let courseData = that.getCourseDataById(id);
      
      if (obj._initial) {
        for (let i in courseData) {
          if (courseData.hasOwnProperty(i)) {
            obj[i] = courseData[i];
          }
        }
        delete obj._initial;
      }
      
      obj.places = _.union(obj.places, courseData.places);
      return obj;
      
    }, {_initial: true});
    
    let req;
    
    if (that.courseOrder === 'distance') {
      // デフォルトでは距離順になる。。はず
      req = {places: cd.places, course_data: cd};
    } else {
      req = {places: cd.places, order: cd.places, course_data: cd};
    }
    
    let dfd = jQuery.Deferred();
    
    that.requestPlaces(req).then((res) => {
      
      let places = res.places;
      
      if (!places[0]) {
        return;
      }
      
      // 地図の中心と、現在地マーカーを最初の施設に移動
      // displayCourseRoute内で実行すると現在地マーカードラッグ時にも実行され元に戻ってしまう。
      // var start = new that.g.LatLng(places[0].lat, places[0].lng);
      // that.moveMap(start.lat(), start.lng());
      // that.updateCurrentLocation(start);
      
      // that.reSearch({lat: start.lat(), lng: start.lng()}).then(function(res){
      dfd.resolve(res);
      // });
    });
    return dfd;
  }
  
  getPolygonWithin (params, data) {
    let search_url = this.repositoryOptions.searchApi + '?' + $.param(params);
    // Ajax通信開始
    return $.ajax({
      type: 'POST',
      data: data,
      url: search_url,
      dataType: "json"
    });
      //.then(function (res) {
      //  console.log(res.landslide, res.flooded, res.river);
      //  return res;
      //});
  }
  
  // ====================== レイヤ関連メソッド ======================
  
  initLayers(){
    
    let that = this;
    let time = (new Date()).getTime();
    let zIndex = 1000;  // レイヤのz-index: レイヤーキーの順に重ねる
    $.each(this.layerKeys, function(){
  
      let name = this.toString();
      let path;
      
      let level = name.match(/\d/);
      let riverName = name.replace(/\d/, '');
      
      if (_.isFunction(that.kmzPath)) {
        
        if (level) {
          level = level[0];
          path = that.kmzPath(riverName) + '&time=' + time + '&value=' + level;
        } else {
          path = that.kmzPath(name) + '&time=' + time;
        }
        
      } else {
  
        if (level) {
          level = level[0];
          path = that.kmzPath + name + '/' + level + '.kmz?time=' + time;
        } else {
          path = that.kmzPath + name + '.kmz?time=' + time;
        }
        
      }
      
      let layer = new google.maps.KmlLayer(path, {preserveViewport: true, zIndex: zIndex});
      
      if (level) {
        
        if (!that.layerCache[riverName]) {
          that.layerCache[riverName] = [];
        }
  
        that.layerCache[riverName].push(layer);
        
      } else {
        that.layerCache[name] = layer;
      }
      
      //// 浸水深用
      //var m = name.match(/\d/);
      //if (m){
      //  layer.setZIndex(1000 - parseInt(m[0], 10));
      //}
      
      // 読み込み完了した時
      google.maps.event.addListener(layer, 'metadata_changed', () => {
        // on success
      });
      google.maps.event.addListener(layer, 'status_changed', () => {
        // on finish
        that.displayLoading(false);
      });
      
      that.layerInfo[name] = new google.maps.InfoWindow({
        maxWidth: 300
      });
      
      //that.layerInfo[name].setContent(that.getLayerInfo(name));
      // info.close();
      
      // レイヤをクリックすると、そのレイヤの情報を情報ウィンドウに表示する
      // 背後に他のレイヤがある場合、そのレイヤの情報も表示する
      google.maps.event.addListener(layer, 'click', (event) => {
  
        // レイヤ情報ウィンドウの内容を一旦初期化する
        that.layerInfo[name].setContent(null);
        
        // レイヤ名からレイヤ種別名のみ取り出す
        let layerType = name.split('/')[1];
        layerType = layerType.replace(/_sp/, '');
        layerType = layerType.replace(/\d/, '');
        
        // レイヤクリック地点の座標を取得
        let lat = event.latLng.lat();
        let lng = event.latLng.lng();
        
        // クリックしたレイヤの情報を取得
        let iwContent = that.getLayerInfo(name);
  
        // クリックしたレイヤと同地点にある背後のレイヤの浸水深を取得
        let url_e = that.layerInfoAPI + 'lat=' + lat + '&lng=' + lng + '&radius=0.00001&scopes=evacuation';
        let url_f = that.layerInfoAPI + 'lat=' + lat + '&lng=' + lng + '&radius=0.00001&scopes=flooded';
        let url_s = that.layerInfoAPI + 'lat=' + lat + '&lng=' + lng + '&radius=0.00001&scopes=sediment';
  
        // 各レイヤの表示状態を取得
        let riverVisible = that.riverIndicator.is(':visible');
        let inlandVisible = that.inlandIndicator.is(':visible');
        let sedimentVisible = that.sedimentIndicator.is(':visible');
        
        $.when(
  
          $.ajax({url: url_e, dataType: 'json'}),
          $.ajax({url: url_s, dataType: 'json'}),
          $.ajax({url: url_f, dataType: 'json'})

        ).done( function (res1, res2, res3) {
  
          let evacInfo = res1[0];
          let sediInfo = res2[0];
          let floodInfo = res3[0];
          
          if ( riverVisible && evacInfo ) {
    
            let info = null;
            let log = {};
    
            _.forEach(evacInfo.evacuation, function (value, key) {
      
              if (layerType === 'line' || layerType === 'area_yodo') {
                if (key === 'area_other') {
                  info = that.getLayerInfo('evacuation/' + key);
                }
              }
      
              if (info && !log[key]) {
                iwContent += '<hr class="ct-iw-hr" />' + info;
                log[key] = key;
              }
      
              info = null;
      
            });
    
            that.layerInfo[name].setContent(iwContent);
            that.jumpToLegend();
    
          }
  
          if ( sedimentVisible && sediInfo ) {
    
            let info = null;
            let _key = null;
            let log = {};
    
            _.forEach(sediInfo.sediment, function (value, key) {
      
              _key = key.replace(/_sp/, '');
      
              // 当該レイヤと、レイヤ情報が異なる場合、背後に土砂災害レイヤがある可能性がある
              // 土砂災害レイヤ情報の取得を試みる
              if ( layerType !== _key ) {
                info = that.getLayerInfo('sediment/' + key);
              }
      
              // 土砂災害レイヤ情報が取得できた = 背後に土砂災害レイヤがある
              // その土砂災害レイヤの情報を情報ウィンドウに追加する
              if (info && !log[_key]) {
                iwContent += '<hr class="ct-iw-hr" />' + info;
                log[_key] = _key;
              }
      
              info = null;
      
            });
    
            that.layerInfo[name].setContent(iwContent);
            that.jumpToLegend();
    
          }
  
          if ( (riverVisible || inlandVisible) && floodInfo ) {
    
            let depth = null;
            let backLayer = null;
    
            // 外水はん濫の場合
            if ( riverVisible ) {
              backLayer = that.selectedRiver;
            }
    
            // 内水はん濫の場合
            if ( inlandVisible ) {
              backLayer = 'naisui';
            }
    
            // 当該レイヤと、選択されたレイヤが異なる場合、背後にレイヤがある可能性がある
            // 同地点のレイヤ情報から、選択されたレイヤの浸水深が取得できるか試みる
            if (layerType !== backLayer) {
              depth = floodInfo.flooded[backLayer];
            }
    
            // 浸水深が取得できた = 背後に水害レイヤがある
            // その水害レイヤの情報を情報ウィンドウに追加する
            if (depth) {
              iwContent += '<hr class="ct-iw-hr" />' + that.getLayerInfo('flooded/' + backLayer + depth.toString());
            }
    
            that.layerInfo[name].setContent(iwContent);
            that.jumpToLegend();
    
          }
          
        });
        
        that.closeLayerInfo();
        that.map.closeMarkerPopup();
        
        // open
        that.layerInfo[name].setPosition(event.latLng);
        that.layerInfo[name].open(that.map.getMap());
        $(that).trigger('ihLayerOpenInfoWindow', [that.layerInfo[name], name, event.latLng]);
        
        return false;
        
      });
  
      zIndex--;
      
    });
  }
  
  closeLayerInfo(){
    
    let that = this;
    
    // close all info
    for (let i in that.layerInfo) {
      if (that.layerInfo.hasOwnProperty(i)) {
        that.layerInfo[i].close();
      }
    }
    
  }
  
  showLayer(key){
    
    if (!this.layerCache[key]) {
      if (this.debug) {
        console.log('undefined layer: ' + key);
      }
      return;
    }
    if (this.debug) {
      console.log('show:' + key);
    }
  
    this.closeLayerInfo();
    this.setLayer(key, true);
    this.displayLoading(true);
    
  }
  
  hideLayer(key){
    
    if (!this.layerCache[key]){
      if (this.debug){
        console.log('undefined layer: ' + key);
      }
      return;
    }
  
    this.setLayer(key, false);
    
  }
  
  hideLayers(condition){
    
    for (let i in this.layerCache){
      
      if (this.layerCache.hasOwnProperty(i)) {
        
        if (!condition || i.match(condition)) {
          
          if (Array.isArray(this.layerCache[i])) {
    
            for (let j = 0; j < this.layerCache[i].length; j++) {
      
              this.layerCache[i][j].setMap(null);
      
            }
            
          } else {
    
            this.layerCache[i].setMap(null);
    
          }
        }
      }
    }
    
  }
  
  setLayer(key, enable){
  
    if (Array.isArray(this.layerCache[key])) {
    
      for (let i = 0; i < this.layerCache[key].length; i++) {
  
        if (enable) {
          this.layerCache[key][i].setMap(this.map.getMap());
        } else {
          this.layerCache[key][i].setMap(null);
        }
        
      }
      
    } else {
      
      if (enable) {
        this.layerCache[key].setMap(this.map.getMap());
      } else {
        this.layerCache[key].setMap(null);
      }
  
    }
    
  }
  
  // ====================== おすすめコース関連メソッド ======================
  
  /**
   * おすすめコース描画の初期化
   *
   * this.coursesにコースデータを入れておく
   *
   */
  initCourse(){
  
    let latlngRegex = /([\d\.]+):([\d\.]+)/;
    
    /*
      placesの解釈
        - 空はリスト分割
        - (33.1234:135.1234) => lat,lng
        - 数値はplaceId
     */
    _.each(this.courses, (course) => {
      course.places = _.map(course.places, (place) => {
        
        if ($.isNumeric(place)) {
          return parseInt(place, 10);
        }
        
        let m = place.match(latlngRegex);
        
        if (m){
          return new google.maps.LatLng(m[1], m[2]);
        }
        
        return {separator: true};
        
      });
    });
    
    // 本来の値を退避しておく
    this.courses_keep_to_show_direction_on_marker_click = this.show_direction_on_marker_click;
    
  }
  
  /**
   *
   * @param  {Number} id course id
   * @return {jQuery.Deferred}
   */
  openCourse(id){
    
    let that = this;
    let cd = that.getCourseDataById(id);
    let req;
    
    if (that.courseOrder === 'distance') {
      // デフォルトでは距離順になる。。はず
      req = {places: cd.places, course_data: cd};
    } else {
      req = {places: cd.places, order: cd.places, course_data: cd};
    }
  
    let dfd = jQuery.Deferred();
    
    that.requestPlaces(req).then((res) => {
      
      let places = res.places;
      
      if (!places[0]) {
        return;
      }
      
      // 地図の中心と、現在地マーカーを最初の施設に移動
      // displayCourseRoute内で実行すると現在地マーカードラッグ時にも実行され元に戻ってしまう。
      // var start = new that.g.LatLng(places[0].lat, places[0].lng);
      // that.moveMap(start.lat(), start.lng());
      // that.updateCurrentLocation(start);
      
      // that.reSearch({lat: start.lat(), lng: start.lng()}).then(function(res){
      dfd.resolve(res);
      // });
    });
    
    return dfd;
  
  }
  
  fillCourseListItem(link, courseObj){
    
    let that = this;
    
    if (link.find('.js-name').length > 0) {
      link.find('.js-name').text(courseObj.name);
    } else {
      link.text(courseObj.name);
    }
    
    let img = link.find('.js-image');
    
    if (courseObj.image) {
      img.attr('src', courseObj.image);
    } else {
      img.attr('src', courseObj.image);
      // img.remove();
    }
    
    link.on('click', function(){
      that.openCourse(courseObj.id);
      $('#page-list').panel('open');
    });
    
    return link;
    
  }
  
  /**
   *
   * @param  {Number} id [description]
   * @return {[type]}    [description]
   */
  getCourseDataById(id){
    
    let ret = null;
    
    $.each(this.courses, (i, course) => {
      if (course.id === id){
        ret = course;
      }
    });
    
    return ret;
    
  }
  
  /**
   * ルートを地図に描画する
   *
   * @param {Array} places 施設情報
   * @param {object} course コース情報
   * @returns {undefined}
   */
  displayCourseRoute(places, course) {
    
    let that = this;
    let points = [[]];
    let i = 0;
    
    // コース分割
    _.each(course.places, (p) => {
      
      if (p && p.separator) {
        i++;
        points[i] = [];
        return;
      }
      
      if ($.isNumeric(p)) {
        let place = _.find(places, (place) => {
          return place && place.id === p;
        });
        if (place.lat && place.lng) {
          points[i].push(new google.maps.LatLng(place.lat, place.lng));
        }
      } else {
        if (p && p.lat() && p.lng()) {
          points[i].push(p);
        }
      }
      
    });
  
    // 分割した分レンダラーを用意
    for (let i = 0; i < points.length; i++) {
      this.courseRenderers.push(this.createDirectionsRenderer({
        polylineOptions: this.getCoursePolylineOptions()
      }));
    }
  
    $(this).trigger('ihBeforeDisplayCourse', [places, course]);
  
    // setタイプの場合はルート描画しない
    if (course.type === 'set') {
      return;
    }
    
    return $.when(_.map(points, (p, i) => {
      return that.renderCoursePoints(p, that.courseRenderers[i]);
    }), () => {
      console.log(arguments);
    });
  
    // 以前のオプション
    // if (course.draw_from === 'points'){
    //   // 位置を1点ずつ指定する場合
  
    //   var path = this.getPolyline().getPath();
    //   $.each(course.draw_from_points_by, function(){
    //     var point = this;
    //     path.push(new that.g.LatLng(point[0], point[1]));
    //   });
    //   return;
  
    // if (course.course_places){
    //   // 施設とは別の情報でルートを描画したい場合（経由地が8越える場合など）
    //   points = course.course_places;
    // }else{
    //   points = course.places;
    // }
  
    // if (course.draw_from_places_by === 'line'){
    //   var path = this.getPolyline().getPath();
    //   path.push(start);
    //   $.each(waypoints, function(i, waypoint){
    //     path.push(waypoint.location);
    //   });
    //   path.push(end);
    
  }
  
  /**
   *
   * @return {jQuery.Deferred} [description]
   */
  renderCoursePoints(points, renderer){
    
    let that = this;
    let waypoints = [];
    let n = points.length;
    
    // Set the waypoints, the start and the end
    for (let i = 1; i < n - 1; i++) {
      waypoints.push({
        "location": points[i],
        "stopover": true
      });
    }
  
    let start = points[0];
    let end =  points[n-1];
    let travel_mode = "WALKING";  // DRIVING, BICYCLING, WALKING
    let request = {
      origin: start,
      destination: end,
      waypoints: waypoints,
      travelMode: google.maps.DirectionsTravelMode[travel_mode]
    };
  
    let dfd = jQuery.Deferred();
    
    return that.requestToDirectionService(request, renderer)
    .then((response, status) => {})
    .fail((response, status) => {
      // error
      console.log(response, status);
      that.clearCourseRenderers();
    });
  }
  
  /**
   * 描画したコースを消す
   * @returns {undefined}
   */
  clearCourseRoutes(){
    
    // polylineの場合
    let path = this.getPolyline().getPath();
    
    if (path) {
      path.clear();
    }
    
    // directionの場合
    if (this.courseRenderers) {
      this.clearCourseRenderers();
    }
    
  }
  
  clearCourseRenderers(){
    
    let that = this;
    
    _.each(that.courseRenderers, (r) => {
      r.setMap(null);
    });
    
    that.courseRenderers = [];
    
  }
  
  getPolyline(){
    
    if (this.poly) {
      return this.poly;
    }
    
    // this.poly = new this.g.Polyline(this.getCoursePolylineOptions());
    this.poly = new google.maps.Polyline(this.getCoursePolylineOptions());
    this.poly.setMap(this.map.getMap());
    
    return this.poly;
    
  }
  
  getCoursePolylineOptions(){
    return {
      strokeColor: '#165be5',
      strokeOpacity: 0.5,
      strokeWeight: 6
    };
  }
  
  // =========== ih.sakaimapから移設。マップアプリ間で汎用性のありそうなメソッド ===========
  
  /**
   * 中心点がパネルに隠れるかどうか
   * @returns {Boolean}
   */
  isMobileSize(){
    return  $('.ui-panel').width() / $(window).width() > 0.42;
  }
  
  // IHChikatsuAsukaと仕様が異なる
  readyForPagesAndPanels(){
    
    let that = this;
    let width = $(window).width();
    let panelCloser = $('.panel-closer');
  
    // ウィンドウサイズが指定サイズ以上の時に、サイドパネルの閉じるボタンを非表示にする
    // ウィンドウリサイズ時にも実行
    // (マップビューポートをサイドパネル分縮小する設定が有効な場合のみ)
    if (that.mapOptions.adjustView.enable && width >= that.mapOptions.adjustView.viewSize){
      panelCloser.hide();
    }
    
    // #home、つまりマップのあるページに戻ってきた時、リサイズイベントを起動する
    $('#home').on('pageshow', () => {
      google.maps.event.trigger(that.map.getMap(), 'resize');
    });
    
    // パネルを開いた時、contentの高さを調整する。
    // fixedにしないと、ウィンドウ全体がスクロールしてしまう
    let openPanel = null;
    let panel = $('*[data-role=panel]');
    
    panel.on('panelopen', function(){
      let h = window.innerHeight - 120;
      $(this).find('.panel-content').height(h);
      openPanel = $(this);
    });
    
    panel.on('panelclose', () => {
      openPanel = null;
    });
    
    $(window).bind("resize", (event) => {
      if (openPanel) {
        let h = window.innerHeight - 140;
        openPanel.find('.panel-content').height(h);
      }
  
      width = $(window).width();
      if (that.mapOptions.adjustView.enable && width >= that.mapOptions.adjustView.viewSize){
        panelCloser.hide();
      } else {
        panelCloser.show();
      }
      
    });
    
  }
  
  /**
   * 施設メニューの選択を全て解除
   *
   */
  clearFacilitySelector(){
    
    let that = this;
  
    $('.js-facility-category').each(function(){
  
      $(this).prop('checked', false);
      $(this).checkboxradio();
      $(this).checkboxradio('refresh');
    
    });
    
    $('.js-facility-selector').each(function(){
      
      let placetype = $(this).data('placetype');
      
      that.flag_display_facility[placetype] = false;
      
      $(this).prop('checked', false);
      $(this).checkboxradio();
      $(this).checkboxradio('refresh');
      
    });
  }
  
  removeContents(){
  
    // ヘッダ・詳細パネルの標高を削除
    //$('.location-bar-elevation').remove();
    $('.js-elevation-chart').remove();
    
    // 詳細画面からのオススメコース表示を削除
    $('.iw-courses-heading').remove();
    $('.iw-courses').remove();
  
    // 結果一覧でのコースを削除
    $('.js-current-course-holder').remove();
    
  }
  
  setClosablePOI(){
  
    let that = this;
    let fx = google.maps.InfoWindow.prototype.setPosition;
    
    google.maps.InfoWindow.prototype.setPosition = function(){
      
      if (this.logAsInternal) {
        
        that.poi = this;
        
        google.maps.event.addListenerOnce(this, 'map_changed',function () {
          
          var map = this.getMap();
          
          if (map) {
            google.maps.event.trigger(map, 'click', {latLng: this.getPosition()});
          }
          
        });
        
      }
      fx.apply(this, arguments);
    };
  }
  
  /**
   * ページ表示時に、リストやラジオボタンの選択を初期化する
   * 選択後にブラウザバックした後、再びマップに戻ると、選択が残ったままになるため [JS仕様]
   *
   */
  initSelectors(flood, river, sediment){
    
    let riverSelector = $('.js-river-select');
    let floodSelector = $(".kiken-shinsui");
    let sedimentSelector = $(".js-saigai-select");
    
    window.onpageshow = function() {
      
      if (flood) {
  
        // はん濫選択ボタンを初期化
        floodSelector.find('input').each(function () {
    
          if ( $(this).val() == '3' ) {
            $(this).prop('checked', true);
          } else {
            $(this).prop('checked', false);
          }
    
          $(this).checkboxradio('refresh');
    
        });
        
      }
  
      if (river) {
  
        // 河川選択ボタンを初期化
        riverSelector.each(function () {
    
          if ( $(this).val() != '' ) {
            $(this).val('0');
            $(this).selectmenu('refresh');
          }
    
        });
        
      }
  
      if (sediment) {
  
        // 土砂災害選択ボタンを初期化
        if ( sedimentSelector.prop('checked') ) {
    
          sedimentSelector.prop('checked', false);
          sedimentSelector.checkboxradio('refresh');
    
        }
        
      }
      
      $('#page-disaster').removeClass('ui-disabled');
      
    };
    
  }
  
  /**
   * 詳細パネルに施設画像のカルーセルを生成する
   * TODO: ライブラリを変更する必要があるかも
   *
   * @param place
   * @param popup
   */
  createCarousel(place, popup){
    
    if ( place.image && popup.find('.iw-image-popup').length ) {
      
      let path = place.image;       // 画像パス
      let imageTitle = place.name;  // 画像名称
      let title = null;             // img要素のtitle属性（カルーセルのキャプションに利用される）
    
      // 複数の画像パス・画像名称を '|' で分割
      path = path.split('|');
      imageTitle = imageTitle.split('|');
    
      // 画像パスを整形
      for (let i = 0; i < path.length; i++) {
      
        // 改行や空白を削除
        path[i] = path[i].replace(/[\n\r\s]/g, '');
      
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!path[i].match(/^http/)) {
          path[i] = this.place_image_path + path[i];
        }
      
      }
  
      // 画像名称を整形
      for(let i = 0; i < imageTitle.length; i++) {
        // 改行や空白を削除
        imageTitle[i] = imageTitle[i].replace(/[\n\r\s]/g, '');
      }
    
      // 詳細パネルのサムネイルを表示
      popup.find('.iw-image-popup').show();
    
      // 画像枚数が2枚以上ならサムネイル横に枚数を表示
      if (path.length > 1) {
        $('#iw-image-count').text(path.length + '枚');
      }
    
      // モダール起動部の要素を取得
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
    
      // モーダルが未生成の場合、新規生成
      if ($('#image-popup').length === 0) {
      
        // モーダルを生成
        let imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo(imagePopupContainer);
        //var imagePopupClose = $('<a href="#" data-rel="back" data-role="button" data-theme="a" class="ui-btn-right ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-notext ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text">Close</span><span class="ui-icon ui-icon-delete ui-icon-shadow">&nbsp;</span></span></a>').appendTo( imagePopup);
        //var img = $('<img>').appendTo( imagePopup );
      
        // モーダルを開始
        imagePopup.popup();
      
        // モーダルを閉じるボタンを追加
        let closer = $('<button id="#carousel-closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">閉じる</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
      
        // モーダルを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      
      // モーダルが生成済みなら、更新のためにカルーセル・画像枚数を削除
      } else {
        $('.bx-wrapper').remove();
        $('#iw-image-count').text('');
        
        // カルーセルをオフにする事による応急処置
        $('.carousel').remove();
        
      }
    
      // カルーセル用の<div>を生成してモーダルに追加
      let carousel = $('<div class="carousel"></div>');
      carousel.appendTo('#image-popup');
  
      // 読み込まれた画像枚数
      let imgCount = 0;
      
      // <img>を生成してカルーセル用<div>に追加
      for(let i = 0; i < path.length; i++) {
    
        // title属性に画像名称を設定
        if(imageTitle[i]) {
          title = imageTitle[i];
        }
    
        // 各画像表示用の<div>を生成し、カルーセル用<div>に追加
        let imgDiv = $('<div></div>');
        imgDiv.appendTo(carousel);
        
        // <img>を生成、タイトル属性を設定し、画像表示用<div>に追加
        let img = $('<img>');
        img.attr('title', title);
        img.appendTo(imgDiv);
    
        // 全ての画像が読込まれたら、カルーセルを開始
        img.bind('load', () => {
      
          imgCount++;
      
          if (imgCount === path.length) {
            // カルーセル画像のレスポンシブ不具合の応急処置
            // カルーセルを取りやめて１枚だけシンプル表示
            //this.startCarousel();
          }
      
        });
        
        // <img>の画像を読み込み
        // bindのコールバックが用意される前に画像読み込みが終了しないよう、この位置で読み込む
        img.attr('src', path[i]);
    
      }
    
    } else {
      popup.find('.iw-image-popup').hide();
    }
  
    // 画像提供元を表示する
    if (place.image_label && popup.find('.iw-image-label').length) {
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').text(place.image_label);
    } else {
      popup.find('.iw-image-label-item').hide();
    }
    
  }
  
  startCarousel() {
    
    let carousel = $('.carousel');
    
    carousel.bxSlider({
      slideWidth: 600,
      minSlides: 1,
      maxSlides: 1,
      slideMargin: 5,
      infiniteLoop: false,
      hideControlOnEnd: true,
      captions: true
    });
    
  }
  
  displayLocationBar(){
    
    let locationBar = $('.js-address-display');
  
    locationBar.text('');
  
    this.getAddress(this.map.getCenter(), (address) => {
      locationBar.text(address.replace(/日本、/g, ''));
    });
    
  }
  
  /**
   * 町域レイヤを非表示にする
   */
  clearTownLayer(){
  
    let length = this.townLayer.length;
    
    if (length !== 0) {
      for (let i = 0; i < length; i++) {
        this.townLayer[i].setMap(null);
      }
    }
    
  }
  
  /**
   * 町名・施設名パネルの制御
   */
  controlTownIndex(){
    
    let that = this;
    let index = $('.address-index');
    let places = $('.address-places');
    let features = $('.address-feature');
    let back = $('.address-back');
    let info = $('.address-info');
    let result = {};
    
    // 町名による現在地マーカ・地図中心位置の移動
    places.each(function(){
      
      result[$(this).data('index')] = $(this);
  
      $(this).find('a').each(function(){
  
        $(this).on('click', function(){
  
          let layerID = $(this).data('layer').toString().split(',');
          that.setCenterByTownLatLng( $(this) );
          that.showTownLayer(layerID);
          
        });
        
      });
      
    });
  
    // 施設名による現在地マーカ・地図中心位置の移動
    features.each(function(){
    
      $(this).find('a').each(function(){
      
        $(this).on('click', function(){
  
          that.setCenterByTownLatLng( $(this) );
        
        });
      
      });
    
    });
    
    // 初期状態で、町名リストと検索結果表示欄を非表示にする
    places.hide();
    info.hide();
    
    // 50音表から選ぶと、50音表を非表示にし、町名リストと検索結果表示欄を表示する
    index.find('a').each(function(){
      
      $(this).on('click', function(){
  
        let c = $(this).data('index');
        
        index.hide();
        info.show();
        result[c].show();
        
        $('.address-current').text(c);
        $('.address-count').text(result[c].find('td').length);
        
        return false;
      });
      
    });
    
    // 戻るボタンを押すと、町名リストと検索結果表示欄を非表示にし、50音表を表示する
    back.on('click', function(){
      index.show();
      places.hide();
      info.hide();
      return false;
    });
  }
  
  jumpToLegend(){
    
    let pageDisaster = $('#page-disaster');
    
    $('.ct-jump-to-legend').on('click', function () {
  
      pageDisaster.panel('open');
      let legend = $(this).data('legend');
  
      let content = pageDisaster.find(".ui-content");
      let targetElem = $('#ct_legend_' + legend);
      let pos = targetElem.offset().top + content.scrollTop() - 20;
      content.animate({scrollTop:pos}, 200, 'swing');
      
    });
    
  }
  
  changeCenterByMultiTownID(){
  
    let qs = this.getQueryString();
    let that = this;
  
    if (qs.multi_area) {
    
      let townIDs = qs.multi_area.toString().split(',');
      that.showTownLayer(townIDs);
    
    }
    
    if (qs.center_area) {
  
      let townID = qs.center_area.toString();
      let places = $('.address-places');
      let that = this;
  
      places.each(function(){
        $(this).find('a').each(function(){
      
          let layerID = $(this).data('layer').toString();
      
          if ( townID === layerID ) {
            that.setCenterByTownLatLng( $(this) );
          }
      
        });
      });
      
    }
    
  }
  
  changeCenterByTownID(){
    
    let qs = this.getQueryString();
    let that = this;
    
    if (qs.area) {
  
      let townID = qs.area.toString();
      let places = $('.address-places');
      
      places.each(function(){
        $(this).find('a').each(function(){
    
          let layerID = $(this).data('layer').toString();
  
          if ( townID === layerID ) {
  
            let id = layerID.split(',');
            that.setCenterByTownLatLng( $(this) );
            that.showTownLayer(id);
            
          }
          
        });
        
      });
      
    }
    
  }
  
  setCenterByTownLatLng(town){
  
    let lat = town.data('lat');
    let lng = town.data('lng');
    let latlng = this.map.createLatLng(lat, lng);
    this.map.setCenterAndCurrentLocation(latlng);
    $(this.map).trigger('ihUpdateCenterMarker');
    
  }
  
  showTownLayer(layerID){
  
    let time = (new Date()).getTime();
    
    this.clearTownLayer();
    
    for (let i = 0; i < layerID.length; i++) {
      let path = this.townKMLPath + layerID[i] + '.kml?time=' + time;
      this.townLayer[i] = new google.maps.KmlLayer(path, {preserveViewport: true, zIndex: 0});
      this.townLayer[i].setMap(this.map.getMap());
    }
    
  }
  
};


// WEBPACK FOOTER //
// ./map/js/ih/extend/IHCityTakatsuki.js